<div class="loader-container" *ngIf="message$">
  <!-- <div class="loader"></div> -->

  <div class="arrows">
    <svg *ngIf="_animating" [@animation1]="_animate" xmlns="http://www.w3.org/2000/svg" class="brand-line brand-line-1" >
      <defs >
        <linearGradient  id="grad1" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" style="stop-color: rgb(216,97,3); stop-opacity: 1;"></stop>
          <stop offset="45%" style="stop-color: rgb(234,16,6); stop-opacity: 1;"></stop>
          <stop offset="100%" style="stop-color: rgb(251,201,55); stop-opacity: 1;"></stop>
        </linearGradient>
      </defs>
      <polygon  points="0,3 102,0 102,6" fill="url(#grad1)"></polygon>
    </svg>
    <!-- <svg [@animation2]="_animate" xmlns="http://www.w3.org/2000/svg" class="brand-line brand-line-2">
      <polygon points="0,3 92,0 92,6" fill="url(#grad1)"></polygon>
    </svg>
    <svg [@animation3]="_animate" xmlns="http://www.w3.org/2000/svg" class="brand-line brand-line-3">
      <polygon points="0,3 82,0 82,6" fill="url(#grad1)"></polygon>
    </svg> -->
  </div>
  <div class="loader-message" [innerHtml]="message$ | async"></div>
</div>
